
import { EnviarMensajeRequest } from './../../services/request/enviarMensajeRequest';
import { EnviarEscribiendoRequest } from './../../services/request/enviarEscribiendoRequest';
import { ChatService } from './../../services/chat.service';
import { Message } from './../../models/message';
import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange, EventEmitter, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { alissMensajes } from '../../utils/aliss-mensajes';

import { regExp } from '../../utils/regularExpresions';
import { LocalStorageService } from 'src/app/asistente-en-linea/services/local-storage.service';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';


@Component({
  selector: 'app-message-form',
  templateUrl: './message-form.component.html',
  styleUrls: ['./message-form.component.scss']
})
export class MessageFormComponent implements OnInit {

  @Input()
  public agentesDisponibles: boolean;

  @Input()
  public message: Message;

  @Input()
  public messages: Message[];

  @Input()
  public positionQueue: number;

  @Input()
  public agenteAssigned: string;

  @Input() participantID: string;
  participantIDChild = '';

  @Input() agentTyping: boolean;

  @Output() procesarRespuesta = new EventEmitter<any>();

  @Output() iniciarChat = new EventEmitter<any>();

  conversationSequenceNumber: number;
  envioHistoricoTimeout = false;
  
  @Input() public ctx: Contexto;

  @Input()
  public mensajesGuardados: Message[] = [];

  @Input()
  public cambioDeServicio: boolean;
  @Input()
  public fueraHorario: boolean;

  constructor(private rest: ChatService,
              private storage: LocalStorageService
    ) { }

  ngOnInit() {  }


public setParticipantIDChild(part) {
  this.participantIDChild = part;
}

public sendHistoricalMessage(): void {
  if ((this.participantIDChild !== '') && (this.mensajesGuardados.length > 0)) {
    this.participantID = this.participantIDChild;
    let historico = '';
    let actor = '';
    for (const m of this.mensajesGuardados) {
      let contenido = m.content;
      // Se utiliza para quitar saltos de linea agregados con el Enter al enviar
      contenido = contenido.replace(regExp.endLine, '');
      if (m.client) {
        actor = this.envioHistoricoTimeout ? 'Usuario: ' : '';
        historico = historico + actor + contenido + '\n';
      } else if (m.system) {
        actor = this.envioHistoricoTimeout ? '* ' : '' ;
        historico = historico + actor + contenido + actor + '\n';
      } else {
        actor = this.envioHistoricoTimeout ? 'Asesor: ' : '';
        historico = historico + actor + contenido + '\n';
      }
    }
    this.message = new Message(historico, 'assets/images/bps-avatar.png',
                                '', new Date(), false, true, 0, 0);
    this.enviarMensaje();
    this.mensajesGuardados = [];
    this.envioHistoricoTimeout = false;
    // limpia el textArea
    this.message = new Message('', 'assets/images/user.png', '');
  }
}

  public sendMessage(): void {
    // Se controla haber presionado Enter sin haber escrito mensaje
    let NEWLINE = '\n';
    let CARRIAGERETURN= '\n';

    if (this.message && this.message.content 
      && this.message.content.trim().length > 0 
    	&& this.message.content != NEWLINE 
    	&& this.message.content != CARRIAGERETURN ) {
      this.message.timestamp = new Date();
      this.message.client = true;
      this.messages.push(this.message);
      const mensajeAEnviar = this.message;
      // Si ya hay un agente asignado: envio los mensajes
      if (this.agenteAssigned && this.participantID) {
        this.message = mensajeAEnviar;
        this.enviarMensaje();
      // Si aún no tiene el agente asignado guardo los mensajes para enviar despues
      } else {
        if (this.storage.isTimeout()) {
          // Se agrega chequeo de messages undefined para el caso de timeout sin envio de histórico.
          // De todos modos manda el separador de asteriscos para saber que esta conversación viene de un tiemout
           this.mensajesGuardados = (!(this.storage.getMessages() === undefined)) ? this.storage.getMessages() : [];

          this.mensajesGuardados.push(new Message(alissMensajes.separadorHistorico, 'assets/images/bps-avatar.png',
            '', new Date(), false, true, 0, 0));
          this.envioHistoricoTimeout = true;
        }
        this.mensajesGuardados.push(mensajeAEnviar);
        if (!this.participantID) {
          this.iniciarChatPadre();
        }
      }
      // Limpia el textArea
      this.message = new Message('', 'assets/images/user.png', '');
    } else {
      // Caso en el que solamente se ha presionado boton enter sin ingresar texto
      // o se ingresan caracteres vacios
      this.message.content = "";
    }

  }

  enviarMensaje() {
    const req = new EnviarMensajeRequest();
    req.mensaje = this.message.content;
    req.context = this.ctx;
    //el participantID ya se encuentra en el contexto (lo hace el iniciarChat)
    //req.participantID = this.participantID;
    this.rest.enviarMensaje(req).pipe(take(1)).subscribe(result => {
      console.log("Respuesta de enviarMensaje():: %s",JSON.stringify(result));
      if (!(result === undefined)) {
        // Lo pasamos el componente padre para procesar la respuesta
        this.procesarRespuestaPadre(result);
      }
    }, (err) => {
      console.log("Error en enviarMensaje():: mensaje de error: %s",err);
    }
    );
  }

  iniciarChatPadre() {
    this.iniciarChat.next();
  }

  procesarRespuestaPadre(result: any) {
    this.procesarRespuesta.next(result);
  }

  escribiendo(indicador) {
    if ((this.participantID !== '') && (this.participantID !== undefined)) {
      const req = new EnviarEscribiendoRequest();
      req.indicador = indicador;
      req.participantID = this.participantID;
      this.rest.enviarEscribiendo(req).pipe(take(1)).subscribe(res => {
        //No se hace nada con la respuesta
      });
    }
  }

}
